export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
              <i className="ri-mail-send-line text-primary-500 text-sm"></i>
              <span className="text-primary-400 text-xs font-medium">联系我们</span>
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">投稿与合作</h2>
            <p className="text-foreground-500 text-sm mt-3">
              欢迎剧评投稿、资源合作与商务洽谈，我们的编辑团队期待你的来信
            </p>
          </div>

          <div className="bg-background-100 border border-background-200/60 rounded-xl p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="text-center p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/15 mx-auto mb-3">
                  <i className="ri-edit-2-line text-primary-500 text-xl"></i>
                </div>
                <h4 className="text-foreground-800 font-heading font-bold text-sm mb-1">剧评投稿</h4>
                <p className="text-foreground-500 text-xs">分享你的观剧心得，优秀剧评将在首页展示</p>
              </div>
              <div className="text-center p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/15 mx-auto mb-3">
                  <i className="ri-links-line text-accent-500 text-xl"></i>
                </div>
                <h4 className="text-foreground-800 font-heading font-bold text-sm mb-1">资源合作</h4>
                <p className="text-foreground-500 text-xs">版权合作与片源引入，共同丰富平台内容生态</p>
              </div>
              <div className="text-center p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-500/15 mx-auto mb-3">
                  <i className="ri-briefcase-line text-secondary-500 text-xl"></i>
                </div>
                <h4 className="text-foreground-800 font-heading font-bold text-sm mb-1">商务洽谈</h4>
                <p className="text-foreground-500 text-xs">广告投放与品牌合作，请联系商务团队详谈</p>
              </div>
            </div>
            <div className="mt-6 pt-5 border-t border-background-200/60 text-center">
              <p className="text-foreground-500 text-sm">
                合作邮箱：<span className="text-primary-500 font-medium">contact@6080tv.example.com</span>
              </p>
              <p className="text-foreground-400 text-xs mt-1">工作日 9:00-18:00 回复</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}